import {Chip} from '@mui/material';

import {getScoreLevelColors, scorePillChipSx} from '../../utils/getScoreLevelColors';

export interface Props {
  score: number;
}

export const TableRowScorePill = ({score}: Props) => {
  const {bgcolor, color} = getScoreLevelColors(score);

  return (
    <Chip
      label={`${score}%`}
      size='small'
      sx={{
        height: 24,
        fontWeight: 600,
        fontSize: 12,
        bgcolor,
        color,
        ...scorePillChipSx,
      }}
    />
  );
};
